import * as React from 'react';
import { connect } from 'react-redux';
import { createSelector } from 'reselect';
import moment from 'moment';

import { redirectToUrl } from 'common/actions/navigationAction';
import {
    getBenefitPriorityDashboard,
    getDateRangeBenefitPrioritiesDashboard,
} from 'features/benefit/selectors/benefitSelectors';
import { BenefitPriorityDashboardItem } from 'features/benefit/models/benefitModels';
import { isLoadingRole, isTenant, isAdmin } from 'features/user/selectors/userSelectors';
import { saveFilters, clearFilters } from 'features/pagination/actions/paginationActions';
import { PaginationView } from 'features/pagination/models/paginationModel';

import { BenefitPriorityDashboardComponent } from '../components/BenefitPriorityDashboard';
import { DashboardPaths } from '../models/dashboardModel';

interface BenefitPriorityDashboardContainerStateProps {
    loading: boolean;
    isUserTenant: boolean;
    isUserAdmin: boolean;
    priorities: BenefitPriorityDashboardItem[];
    dateRange: string[];
}

interface BenefitPriorityDashboardContainerDispatchProps {
    redirectToUrl: typeof redirectToUrl;
    saveFilters: typeof saveFilters;
    clearFilters: typeof clearFilters;
    getDateRangeBenefitPrioritiesDashboard: typeof getDateRangeBenefitPrioritiesDashboard;
}
export type BenefitPriorityDashboardContainerProps = BenefitPriorityDashboardContainerStateProps &
    BenefitPriorityDashboardContainerDispatchProps;

export class BenefitPriorityDashboard extends React.Component<BenefitPriorityDashboardContainerProps> {
    constructor(props: BenefitPriorityDashboardContainerProps) {
        super(props);
        const today = moment().format();
        const threeMonthsAgo = moment().subtract(3, 'months').format();
        this.props.saveFilters({
            paginatedView: PaginationView.BenefitPrioritiesDashboard,
            values: {
                contractDateRangeAfter:
                    this.props.dateRange.length > 0
                        ? this.props.dateRange[0] == null
                            ? undefined
                            : this.props.dateRange[0]
                        : threeMonthsAgo,
                contractDateRangeBefore:
                    this.props.dateRange.length > 0
                        ? this.props.dateRange[1] == null
                            ? undefined
                            : this.props.dateRange[1]
                        : today,
            },
            path: DashboardPaths.BenefitPriorities,
        });
    }

    public render(): JSX.Element {
        return (
            <BenefitPriorityDashboardComponent
                {...this.props}
                redirect={this.props.redirectToUrl}
            />
        );
    }
}
const mapStateToProps = createSelector(
    isLoadingRole,
    isAdmin,
    isTenant,
    getBenefitPriorityDashboard,
    getDateRangeBenefitPrioritiesDashboard,
    (
        loading,
        isUserAdmin,
        isUserTenant,
        priorities,
        dateRange,
    ): BenefitPriorityDashboardContainerStateProps => ({
        loading,
        isUserAdmin,
        isUserTenant,
        priorities,
        dateRange,
    }),
);

export const BenefitPriorityDashboardContainer = connect(mapStateToProps, {
    redirectToUrl,
    saveFilters,
    clearFilters,
})(BenefitPriorityDashboard);
